import * as ActionType from "./rewardWallet.type";

const initialState = {
  wallets: [],
  walletPagination: { total: 0, page: 1, limit: 20, totalPages: 0 },
  stats: null,
  bySource: [],
  transactions: [],
  txnPagination: { total: 0, page: 1, limit: 20, totalPages: 0 },
  txnStats: null,
  rules: [],
};

export const rewardWalletReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_WALLETS:
      return {
        ...state,
        wallets: action.payload.wallets,
        walletPagination: action.payload.pagination,
      };

    case ActionType.GET_WALLET_STATS:
      return { ...state, stats: action.payload.stats, bySource: action.payload.bySource };

    case ActionType.GET_REWARD_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload.transactions,
        txnPagination: action.payload.pagination,
        txnStats: action.payload.stats,
      };

    case ActionType.GET_EARNING_RULES:
      return { ...state, rules: action.payload };

    case ActionType.UPDATE_WALLET_STATUS:
    case ActionType.WALLET_ADJUSTED: {
      const updated = action.payload;
      if (!updated) return state;
      const idx = state.wallets.findIndex(
        (w) => String(w.userId) === String(updated.userId)
      );
      if (idx < 0) return state;
      const next = [...state.wallets];
      next[idx] = { ...next[idx], ...updated, user: next[idx].user };
      return { ...state, wallets: next };
    }

    case ActionType.UPDATE_EARNING_RULE: {
      const updated = action.payload;
      if (!updated) return state;
      const idx = state.rules.findIndex((r) => r.source === updated.source);
      if (idx < 0) return { ...state, rules: [...state.rules, updated] };
      const next = [...state.rules];
      next[idx] = { ...next[idx], ...updated };
      return { ...state, rules: next };
    }

    default:
      return state;
  }
};
